import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Checkbox from '../components/global/checkbox.js'
import { slugify } from '../helpers.js'

let selectedLabels

class CheckboxGroup extends Component {
  constructor(props) {
    super(props)

    selectedLabels = []

    const { label, choices } = this.props

    this.state = {
      unsure: false
    }

    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e, selectedCheckboxKey) {
    const { checked } = e.target

    this.setState({
      unsure: false
    })

    if(!checked) {
      // If not checked, remove from List
      selectedLabels = selectedLabels.filter(item => item !== this.props.choices[selectedCheckboxKey]['label'])
      this.props.choices[selectedCheckboxKey]['checked'] = false
    } else {
      selectedLabels.push(this.props.choices[selectedCheckboxKey]['label'])
      this.props.choices[selectedCheckboxKey]['checked'] = true
    }

    // console.log(this.props.choices)


    this.props.groupUpdated(selectedLabels)
  }

  handleUnsureChange(e) {
    const { checked } = e.target
    let unsure
    if(!checked) {
      unsure = false
    } else {
      unsure = true

      Object
      .keys(this.props.choices)
      .map(key => {
        this.props.choices[key]['checked'] = false
      })

      selectedLabels = []

      this.props.groupUpdated(selectedLabels)

      // this.props.choices[key]['checked']

    }
    this.setState({
      unsure: unsure
    })
  }

  render() {
    let choicesMap = this.props.choices
    let unsureText = `I'm not sure of my ${this.props.label}`

    return (
      (this.props.choices) ?
        <div className={ (this.props.choices.length <= 5) ? "checkbox-group checkbox-group--halves" : "checkbox-group" }>
        {
          Object
          .keys(this.props.choices)
          .map(key => {
            return (
              <Checkbox
                key={ `${slugify(this.props.label)}__${slugify(this.props.choices[key]['label'])}` }
                id={ `${slugify(this.props.label)}__${slugify(this.props.choices[key]['label'])}` }
                name={ `${slugify(this.props.label)}` }
                label={ this.props.choices[key]['label'] }
                isChecked={ this.props.choices[key]['checked'] }
                onChange={ (e) => this.handleChange(e, key) }
              />
            )
          })
        }
        {
          <Checkbox
            key={ `unsure_${this.props.label}` }
            id={ `unsure_${this.props.label}` }
            name={ `unsure_${this.props.label}` }
            label={ unsureText }
            isChecked={ this.state.unsure }
            unsureCheckbox={ true }
            onChange={ (e) => this.handleUnsureChange(e) }
          />
        }
        </div>
      : <p>No options setup</p>
    )
  }
}

export default CheckboxGroup;
